
jQuery(document).ready(function($) {

    //image radio value
    setTimeout( () => {
        $('.image-radio-fields input[type=radio]:checked').each(function() {
            const chosenValue = $(this).siblings('.label').text();
            $(this).closest('.image-radio-fields').find('.chosen-image-radio-value').text(chosenValue);
        });
    }, 400)
    $(document).on('change', '.image-radio-fields input[type=radio]', function() {
        const chosenValue = $(this).siblings('.label').text();
        $(this).closest('.image-radio-fields').find('.chosen-image-radio-value').text(chosenValue);
    });

    //color radio value
    setTimeout( () => {
        $('.color-radio-fields input[type=radio]:checked').each(function() {
            const chosenValue = $(this).siblings('.label').text();
            $(this).closest('.color-radio-fields').find('.chosen-color-radio-value').text(chosenValue);
        });
    }, 400)
    $(document).on('change', '.color-radio-fields input[type=radio]', function() {
        const chosenValue = $(this).siblings('.label').text();
        $(this).closest('.color-radio-fields').find('.chosen-color-radio-value').text(chosenValue);
    });

    const variations = $('.variations_form').attr('data-product_variations');
    //console.log($.parseJSON(variations));

    //reset variations on page load
    /*$('.variations select').each( function() {
        const select = $(this);
        select.val('')
    })

    $('.custom-variation-field').find('input').each(function() {
        resetInput($(this));
        const $select = $(this).closest('.custom-variation-field').next('select');
        updateInputVisibility($(this), $select);
    });*/

    //update inputs
    $('.variations select').each( function() {
        const select = $(this);
        select.prev('.custom-variation-field').find('input').each(function() {
            setTimeout(() => {
                updateInputVisibility($(this), select);
                updateSelectionValues(select)
            }, 200)
        });

        setTimeout(() => {
            updateVariationsSummary($(this));
            updateVariationsVisibility($(this));
        }, 200)
    })

    //update variations visibility on change
    $(document).on('change', '.variations select', function() {  
        updateVariationsSummary($(this));

        var $selects = $('.variations select');
        var changedIndex = $selects.index(this);
        $('.variations select').each(function( index ) {
            if( index !== changedIndex ) {
                setTimeout(() => {
                    updateVariationsVisibility($(this));
                }, 200)
            }
        });
    });

    customVariationFields();
});

function updateVariationsVisibility(select) {
    const options = select.children('option').filter('.enabled.attached');
    if (options && options.length == 1) {
        const enabledValue = options.val();
        if (enabledValue && enabledValue.toLowerCase() === 'piilotettu') {
            select.closest('tr').addClass('hidden');
            options.prop('selected', true);
            updateVariationsSummary(select);
        } else {
            select.closest('tr').removeClass('hidden');
            //reset values
            select.prev('.custom-variation-field').find('input').each(function() {
                //resetInput($(this));
                updateInputVisibility($(this), select);
            });

            //remove hidden value
            select.find('option[value="Piilotettu"], option[value="piilotettu"]').remove()
        }
    } else if( !options || options.length < 1 ) {
        select.closest('tr').addClass('hidden');
    } else {
        select.closest('tr').removeClass('hidden');

        //reset values
        select.prev('.custom-variation-field').find('input').each(function() {
            const val = $(this).val()
            const opt = select.find('option[value="' + val + '"]')
            if( opt.length < 1 ) {
                resetInput($(this));
            }
            updateInputVisibility($(this), select);
        });

        //remove hidden value
        select.find('option[value="Piilotettu"], option[value="piilotettu"]').remove()
    }
}

function customVariationFields() {
    //update values to the original fields
    $(document).on('change', '.custom-variation-field.checkbox-fields input', function() {
        const attrName = $(this).attr('data-attribute');
        let newValue = 'ei';
        if($(this).is(':checked')) {
            const value = $(this).attr('data-value')
            newValue = value
        }
        const $select = $('#' + attrName);
        $select.find('option[value="' + newValue +'"]').prop('selected', true);
        $select.trigger('change');

        updateVariationsSummary($select);
    })

    $(document).on('change', '.custom-variation-field.image-radio-fields input[type=radio]', function() {
        const attrName = $(this).attr('data-attribute');
        const $select = $('#' + attrName);
        $select.find('option[value="' + $(this).val() +'"]').prop('selected', true);
        $select.trigger('change');

        updateVariationsSummary($select)
    })

    $(document).on('change', '.custom-variation-field.color-radio-fields input[type=radio]', function() {
        const attrName = $(this).attr('data-attribute');
        const $select = $('#' + attrName);
        $select.find('option[value="' + $(this).val() +'"]').prop('selected', true);
        $select.trigger('change');

        updateVariationsSummary($select)
    })

    $(document).on('change', '.custom-variation-field.radio-fields input[type=radio]', function() {
        enableCustomInputs()
        const attrName = $(this).attr('data-attribute');
        const $select = $('#' + attrName);
        $select.find('option[value="' + $(this).val() +'"]').prop('selected', true);
        $select.trigger('change');
        const disallowedCombinations = {
            'kayttotapa': {
                'easy': {
                    'mekanismivari': 'harmaa'
                }
            }
        }

        $.each(disallowedCombinations, function(index, element) { // 1 each (kayttotapa)
            if(('pa_' + index) === $select.prop('id')) {
                const selectedVal = $select.find(':selected').val()
                $.each(element, function(index2, element2) { // 2 each (kayttotapa value -> easy)
                    if(index2 === selectedVal) {
                        $.each(element2, function(index3, element3) { // input values to disable -> mekanismivari: harmaa
                            const disallowedInput = $('input[name=attribute_pa_' + index3 + '][value=' + element3 + ']')
                            if( disallowedInput.is(':selected') || disallowedInput.is(':checked')) {
                                // disallowed value is selected, select other value
                                disallowedInput.closest('label').siblings('.input-field').first().find('input[name=attribute_pa_' + index3 + ']').trigger('click')
                            }
                            disallowedInput.prop('disabled', true).closest('label').addClass('custom-disabled')
                        })
                    }
                })
            }

        })
        updateVariationsSummary($select)
    })

    // Reset values
    $(document).on('click', '.reset_variations', function() {
        location.reload();

        /*$('html, body').animate({
            scrollTop: $('.variations_form').offset().top
        }, 500);

        $('.custom-variation-field').find('input').each(function() {
            resetInput($(this));
            const $select = $(this).closest('.custom-variation-field').next('select');
            updateInputVisibility($(this), $select);
            updateVariationsSummary($select);
        });

        $('.variations select').each( function() {
            const options = $(this).children('option').filter('.enabled.attached');
            const row = $(this).closest('tr')
            if (options) {
                options.each( function() {
                    const optionValue = $(this).val()
                    if (optionValue.toLowerCase() === 'piilotettu') {
                        row.addClass('hidden');
                        return
                    }
                })
            }
        })*/
    });
}

function enableCustomInputs() {
    $('.input-field.custom-disabled').each(function(index, element) {
        $(this).find('input:disabled').prop('disabled', false)
        $(this).removeClass('custom-disabled')
    })
}

function resetInput(input) {
    if( input.is(':radio') || input.is(':checkbox') ) {
        input.prop('checked', false)

        if( input.closest('.image-radio-fields.custom-variation-field').find('.chosen-image-radio-value') ) {
            input.closest('.image-radio-fields.custom-variation-field').find('.chosen-image-radio-value').text('')
        }
        if( input.closest('.color-radio-fields.custom-variation-field').find('.chosen-color-radio-value') ) {
            input.closest('.color-radio-fields.custom-variation-field').find('.chosen-color-radio-value').text('')
        }
    } else {
        input.val('');
    }
}

function updateInputVisibility($input, $select) {
    var found = $select.find('option[value="' + $input.val() + '"]').length;
    if(found < 1) {
        $input.closest('.input-field').addClass('hidden');
    } else {
        $input.closest('.input-field').removeClass('hidden');
    }
}

function updateSelectionValues(select) {
    const val = select.val()
    const input = select.prev('.custom-variation-field').find('input[value="' + val + '"]')
    input.prop('checked', true)
    updateVariationsSummary(select)
}

function updateVariationsSummary($select) {
    const val = $select.val();
    const id = $select.attr('id');
    const variation = $('.variations-summary').find('.variation[data-variation-id="' + id + '"]');

    if( !val ) {
        variation.remove();
        return;
    }

    const val_label = $select.find('option[value="' + val + '"]').text();

    if(val.toLowerCase() === 'piilotettu') {
        variation.remove();
        return;
    }
    
    if (variation.length > 0) {
        variation.find('.value').text(val_label);
    } else {
        const labelText = $('label[for="' + id + '"]').text();
        $('.variations-summary').append(
            '<div class="variation" data-variation-id="' + id + '">'+
                '<div class="label">' + labelText + '</div>'+
                '<div class="value">' + val_label + '</div>'+
            '</div>'
        );
    }
}
